<template>
  <div
    class="item"
  >
    <div
      v-if="imageUrl"
      class="corner_icon"
      :style="{ 'background-image': `url(${imageUrl})` }"
    />
    <div class="content_wrap">
      <div class="title">
        <span
          v-if="marketingTag"
          class="t_tag"
        >{{ marketingTag }}</span>
        <span>{{ title }}</span>
      </div>
      <div
        v-if="tags && tags.length"
        class="tags"
      >
        <div
          v-for="(tag, i) in tags"
          :key="i"
          class="tag"
        >
          <span>{{ tag }}</span>
        </div>
      </div>
      <div
        v-if="desc"
        class="desc"
      >
        {{ desc }}
      </div>
      <div class="price_wrap">
        <div
          v-if="payTypeDesc"
          class="payTypeDesc"
        >
          {{ payTypeDesc }}
        </div>
        <div class="price">
          <span class="nuit">¥</span>
          <span class="num">{{ payAmount }}</span>
          <span
            v-if="prevText"
            class="prev"
          >{{ prevText }}</span>
        </div>
        <div
          v-if="totalOriginalPrice"
          class="totalOriginalPrice"
        >
          ¥{{ totalOriginalPrice }}
        </div>

        <div
          v-if="false"
          class="buy-button"
        >
          <van-button
            type="primary"
            color="#F0F3F5"
          >
            购买
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapVant,
} from '@/utils';
import {
  Button,
} from 'vant';

export default {
  components: {
    ...mapVant(
      Button,
    ),
  },
  props: {
    imageUrl: {
      type: String,
      // default: 'https://m4.hellobike.com/resource/AppChangeBattery/AppHelloPowerH5/0_aABm6xjdB_0OstZgV79.png',
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    tags: {
      type: Array,
      default: () => [],
    },

    payAmount: {
      type: Number,
      default: null,
    },
    totalOriginalPrice: {
      type: [String, Number],
      default: null,
    },
    prevText: {
      type: String,
      default: '',
    },
    marketingTag: {
      type: String,
      default: '',
    },
    payTypeDesc: {
      type: String,
      default: '',
    },
  },


};
</script>

<style lang="less" scoped>
.item {
  box-sizing: border-box;
  background: #fff;
  border-radius: 6px;
  // stylelint-disable-next-line
  // border: 0.5px solid #e1e6eb;

  display: flex;
  position: relative;

  &:nth-child(n + 2) {
    margin-top: 24px;
  }

  .corner_icon {
    width: 92px;
    height: 92px;
    background: #f5f5f5;
    border-radius: 6px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-right: 12px;
  }

  .content_wrap {
    position: relative;
    width: 0;
    flex: 1;

    .title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      line-height: 22px;

      span {
        vertical-align: middle;
      }

      .t_tag {
        vertical-align: middle;
        padding: 0 4px;
        margin-right: 4px;
        height: 16px;
        background: linear-gradient(270deg, #ff9c46 0%, #ff5526);
        border-radius: 2px;
        font-size: 10px;
        font-weight: 400;
        color: #fff;
        line-height: 17px;
        display: inline-block;
        // transform: scale(11/12);
      }
    }

    .desc {
      margin-top: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #879099;
      line-height: 17px;
    }

    .tags {
      display: flex;
      flex-wrap: wrap;
      height: 19px;
      width: 120%;
      overflow: hidden;
      transform: scale(10/12);
      transform-origin: left bottom;

      .tag {
        padding: 0 5px;
        height: 19px;
        background: #fef4e7;
        border-radius: 2px;
        font-weight: 400;
        color: #ee8c02;
        margin-right: 5px;
        display: flex;
        justify-items: center;
        align-items: center;

        span {
          font-size: 12px;
          display: inline-block;
        }
      }
    }

    .price_wrap {
      display: flex;
      align-items: flex-end;
      margin-top: 4px;

      .payTypeDesc {
        vertical-align: middle;
        padding: 0 3px;
        margin-right: 8px;
        height: 16px;
        // background: linear-gradient(270deg, #fe7155 0%, #fa4059 100%);
        background: #ffeee9;
        border: 1px solid #ff5600;
        border-radius: 2px;
        font-size: 10px;
        font-weight: 400;
        color: #fa4614;
        line-height: 16px;
        transform: scale(10/12);
      }

      .price {
        position: relative;
        margin-right: 8px;
        font-size: 20px;
        font-weight: bold;
        color: #fb990f;
        display: flex;
        align-items: flex-end;

        .prev {
          font-size: 12px;
          font-weight: 400;
          color: #333;
          margin-right: 4px;
        }

        .nuit {
          margin-right: 2px;
          font-size: 12px;
        }

        .num {
          transform: translateY(2px);
        }
      }

      .totalOriginalPrice {
        font-size: 12px;
        font-weight: 400;
        color: #bcc4cc;
        text-decoration: line-through;
      }

      .buy-button {
        position: absolute;
        right: 0;
        bottom: 0;

        /deep/ .van-button {
          border-radius: 16px;
          height: 28px;
        }

        .van-button__text {
          font-weight: 500;
          color: #ee8c02;
        }
      }
    }
  }
}
</style>
